import React from 'react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const PrivacyPolicy = () => {
  return (
    <div>
      <Navigation />

      <section className="section-padding bg-white" data-testid="privacy-policy">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold mb-8" style={{ color: 'var(--text-dark)' }}>
              Privacy Policy
            </h1>
            
            <div className="space-y-8 text-gray-700 leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Introduction
                </h2>
                <p>
                  At Orbit Marks, we are committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Information We Collect
                </h2>
                <p className="mb-3">
                  We collect information that you provide directly to us, including:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Name and contact information (email address, phone number)</li>
                  <li>Business information and trademark details</li>
                  <li>Payment and billing information</li>
                  <li>Communications between you and our team</li>
                  <li>Any other information you choose to provide</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  How We Use Your Information
                </h2>
                <p className="mb-3">
                  We use the information we collect to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process your trademark registration and related services</li>
                  <li>Communicate with you about our services</li>
                  <li>Send you updates, newsletters, and marketing materials (with your consent)</li>
                  <li>Respond to your inquiries and provide customer support</li>
                  <li>Comply with legal obligations and protect our legal rights</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Information Sharing and Disclosure
                </h2>
                <p className="mb-3">
                  We may share your information in the following circumstances:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>With government agencies (such as USPTO) as required for trademark services</li>
                  <li>With service providers who assist us in operating our business</li>
                  <li>When required by law or to protect our legal rights</li>
                  <li>With your consent or at your direction</li>
                </ul>
                <p className="mt-3">
                  We do not sell your personal information to third parties.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Data Security
                </h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Your Rights
                </h2>
                <p className="mb-3">
                  You have the right to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Access and receive a copy of your personal information</li>
                  <li>Correct inaccurate or incomplete information</li>
                  <li>Request deletion of your personal information</li>
                  <li>Opt-out of marketing communications</li>
                  <li>Withdraw consent where we rely on consent to process your information</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Cookies and Tracking Technologies
                </h2>
                <p>
                  We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Changes to This Privacy Policy
                </h2>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Contact Us
                </h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <p className="mt-3 font-semibold">
                  Email: privacy@mytmbrand.com<br />
                  Phone: 1-800-TM-BRAND
                </p>
              </div>

              <div className="pt-8 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Last Updated: January 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;